import _ from 'lodash';
export const memoizedPartial = function (fn) {
  let memoizedPartialFn;
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  if (fn._memoizeCache) {
    memoizedPartialFn = fn._memoizeCache.get(args);
  } else {
    fn._memoizeCache = new WeakMap();
  }
  if (!memoizedPartialFn) {
    // @ts-expect-error
    memoizedPartialFn = _.partial(fn, ...args);
    fn._memoizeCache.set(args, memoizedPartialFn);
  }
  return memoizedPartialFn;
};
//# sourceMappingURL=memoized-partial.js.map